import React from 'react';
import ReactDOM from 'react-dom';
import AccountAuth from './AccountAuth';

// Self-mount into the My Account login template's root. React/ReactDOM are loaded
// as globals (UMD externals) by the page enqueue, same as the checkout bundle.
function mount() {
  const el = document.getElementById('cn-acct-auth');
  if (!el) return;
  if (ReactDOM.createRoot) {
    ReactDOM.createRoot(el).render(<AccountAuth />);
  } else {
    ReactDOM.render(<AccountAuth />, el);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mount);
} else {
  mount();
}
